import { render } from "./Unsupported.vue?vue&type=template&id=1115ec56&scoped=true"
import script from "./Unsupported.vue?vue&type=script&lang=js"
export * from "./Unsupported.vue?vue&type=script&lang=js"

import "./Unsupported.vue?vue&type=style&index=0&id=1115ec56&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1115ec56"]])

export default __exports__